import { ReactNode } from 'react';

interface BadgeProps {
  children: ReactNode;
  variant?: 'split' | 'keep' | 'fixed' | 'pro' | 'settled' | 'default';
  size?: 'sm' | 'md';
}

export default function Badge({ children, variant = 'default', size = 'sm' }: BadgeProps) {
  const variants = {
    split: 'bg-primary/20 text-primary',
    keep: 'bg-keep/20 text-keep',
    fixed: 'bg-fixed/20 text-fixed',
    pro: 'bg-gradient-to-r from-yellow-500 to-amber-500 text-white',
    settled: 'bg-muted/20 text-muted',
    default: 'bg-muted/20 text-muted'
  };

  const sizes = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm'
  };

  return (
    <span className={`inline-flex items-center rounded-full font-medium ${variants[variant]} ${sizes[size]}`}>
      {children}
    </span>
  );
}
